<script setup lang="ts">
// An on/off switch. The parent decides what a click does (most confirm first).
defineProps<{ on: boolean; label: string }>()
</script>

<template>
    <button
        type="button"
        role="switch"
        :aria-checked="on"
        :aria-label="label"
        class="relative h-4 w-7.5 flex-none rounded-full border-0 p-0 transition-colors"
        :class="on ? 'bg-ok hover:bg-ok' : 'bg-off hover:bg-off'"
    >
        <span
            class="absolute top-0.5 size-3 rounded-full bg-white transition-[left] duration-120"
            :class="on ? 'left-4' : 'left-0.5'"
        />
    </button>
</template>
